import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col, Button, Select } from 'antd';
const { Option } = Select;

const columns = [
  {
    title: 'Month',
    key: 'month',
    width: 25
  },
  {
    title: 'Service Type',
    key: 'serviceType',
    width: 50
  },
  {
    title: 'Count',
    key: 'count',
    width: 25
  }
];

import {
  ssrHandler,
  fetchActiveReportsMetaData,
  fetchBilling
} from '../actions/sessionActions';
import { generateMonthList } from '../utils/assetUtils';

export class Billing extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchCp());
  }
  constructor() {
    super();
    this.state = {
      enterpriseId: null,
      months: null,
      serviceType: null,
      defaultMonths: generateMonthList(3).map(month => month.value)
    };
  }

  componentDidMount() {
    this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchBilling({ months: this.state.defaultMonths });
  }

  reset = () => {
    this.setState({ enterpriseId: null, serviceType: null, months: null });
    this.props.fetchBilling({ months: this.state.defaultMonths });
  };

  handleChange = name => value => {
    this.setState({ [name]: value });
  };

  handleSearch = () => {
    const { enterpriseId, serviceType, months, defaultMonths } = this.state;
    this.props.fetchBilling({
      enterpriseId,
      serviceType,
      months: months && months.length > 0 ? months : defaultMonths
    });
  };

  render() {
    const { metadata, billing } = this.props;
    return (
      <div>
        <Row className="margin-bottom-10">
          <Col span={10}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="enterpriseId"
                id="enterpriseId"
                ref={ref => (this.enterpriseId = ref)}
                showSearch
                style={{ width: '96%' }}
                placeholder="Select Enterprise"
                optionFilterProp="children"
                value={
                  this.state.enterpriseId ? this.state.enterpriseId : undefined
                }
                onChange={this.handleChange('enterpriseId')}
                allowClear={true}
                mode="multiple"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.enterprise.list.map((enterprise, i) => (
                  <Option key={i} value={enterprise.id}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={5}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="serviceType"
                showSearch
                mode="multiple"
                style={{ width: '96%' }}
                placeholder="Select Service Type"
                optionFilterProp="children"
                value={
                  this.state.serviceType ? this.state.serviceType : undefined
                }
                onChange={this.handleChange('serviceType')}
                allowClear={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {billing.filter.serviceType.map((item, i) => (
                  <Option key={i} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={5}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="months"
                showSearch
                mode="multiple"
                style={{ width: '96%' }}
                placeholder="Select Months"
                optionFilterProp="children"
                value={this.state.months ? this.state.months : undefined}
                onChange={this.handleChange('months')}
                allowClear={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {billing.filter.months.map((item, i) => (
                  <Option key={i} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={2} className="text-center">
            <Button
              type="primary"
              className="pull-left"
              onClick={this.handleSearch}
            >
              Search
            </Button>
          </Col>
          <Col span={2} className="text-right">
            <Button type="primary" onClick={this.reset}>
              Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={10} offset={7} className="margin-bottom-10">
            {billing.isFetching ? null : (
              <Fragment>
                {billing.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <table className={`ant-table ant-table-small width-100pt`}>
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {billing.list.map((item, i) => (
                        <tr key={i}>
                          <td className="padding-8">{item.month}</td>
                          <td className="padding-0">
                            <ul className="billing-listing">
                              {Object.keys(item.obj).map((n, i) => (
                                <li key={i}>{n}</li>
                              ))}
                            </ul>
                          </td>
                          <td className="padding-0">
                            <ul className="billing-listing">
                              {Object.keys(item.obj).map((n, i) => (
                                <li key={i}>{item.obj[n]}</li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

Billing.propTypes = {
  config: PropTypes.object,
  metadata: PropTypes.object,
  billing: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchBilling: PropTypes.func
};

Billing.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  billing: state.session.billing
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: data =>
    dispatch(fetchActiveReportsMetaData(data)),
  fetchBilling: query => dispatch(fetchBilling(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Billing)
);
